import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "superuser" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
      class: "tabs",
      tabs: $data.tabs,
      bordered: "",
      "tab-position": "right"
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    ($data.active === 'audit')
      ? (_openBlock(), _createBlock($setup["Audit"], { key: 0 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'ip-whitelist')
      ? (_openBlock(), _createBlock($setup["IpWhitelist"], { key: 1 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'system')
      ? (_openBlock(), _createBlock($setup["System"], { key: 2 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'guardrails')
      ? (_openBlock(), _createBlock($setup["Guardrails"], { key: 3 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'ingest')
      ? (_openBlock(), _createBlock($setup["Ingest"], { key: 4 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'all-agents')
      ? (_openBlock(), _createBlock($setup["AllAgents"], { key: 5 }))
      : _createCommentVNode("v-if", true)
  ]))
}